import { Link } from 'react-router-dom';
import { AlertCircle, BookOpen, ArrowRight, Phone, Mail } from 'lucide-react';
import SEO from '../components/shared/SEO';

const StarterPackNotReadyPage = () => {
  return (
    <div data-testid="starter-pack-not-ready-page" className="min-h-screen bg-[#0A0A0A]">
      <SEO 
        title="Not Ready Yet - Queen B Logistics"
        description="Complete your preparation before applying for the Signature Program program."
      />
      
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="text-center">
          {/* Icon */}
          <div className="w-24 h-24 bg-amber-500/10 flex items-center justify-center mx-auto mb-8">
            <AlertCircle className="w-12 h-12 text-amber-400" />
          </div>
          
          <h1 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold text-white uppercase mb-4">
            Not Ready Yet
          </h1>
          
          <p className="text-xl text-amber-400 mb-6">
            That's okay — building a business takes preparation.
          </p>
          
          <p className="text-zinc-400 mb-8 max-w-lg mx-auto">
            Based on your responses, you may need more time to prepare before starting 
            the Signature Program program. This isn't a rejection — it's an opportunity to 
            set yourself up for success.
          </p>
          
          {/* Preparation Checklist */}
          <div className="bg-zinc-900 border border-zinc-800 p-6 mb-8 text-left">
            <h3 className="text-white font-bold mb-4 flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-[#D4AF37]" />
              Before You Apply Again
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#D4AF37] mt-2 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Form Your LLC</p>
                  <p className="text-zinc-400">Complete your business entity formation first.</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#D4AF37] mt-2 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Secure Startup Capital</p>
                  <p className="text-zinc-400">Budget for filing fees, insurance deposits, and equipment.</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#D4AF37] mt-2 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Research Insurance Options</p>
                  <p className="text-zinc-400">Get quotes and understand coverage requirements.</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#D4AF37] mt-2 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Clear Your Schedule</p>
                  <p className="text-zinc-400">Ensure you can dedicate time to complete tasks on deadline.</p>
                </div>
              </li>
            </ul>
          </div>
          
          {/* Email Notice */}
          <div className="bg-zinc-800/50 border border-zinc-700 p-6 mb-8">
            <div className="flex items-center justify-center gap-3 mb-3">
              <Mail className="w-5 h-5 text-zinc-400" />
              <span className="text-white font-medium">We've Sent You Resources</span>
            </div>
            <p className="text-zinc-400 text-sm">
              Check your email for a preparation guide and checklist to help you 
              get ready for the Signature Program program.
            </p>
          </div>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link 
              to="/build"
              className="w-full sm:w-auto px-6 py-3 border border-zinc-700 text-white hover:bg-zinc-900 transition-colors text-center"
            >
              Back to Signature Program
            </Link>
            <Link 
              to="/contact"
              className="w-full sm:w-auto px-6 py-3 bg-[#D4AF37] text-black font-bold hover:bg-[#F5D47B] transition-colors flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Schedule Consultation
            </Link>
          </div>
          
          {/* Encouragement */}
          <p className="text-zinc-500 text-sm mt-8">
            Many successful carriers needed time to prepare. When you're ready, we'll be here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StarterPackNotReadyPage;
